export { SidebarComponent } from './shared/sidebar/sidebar.component';
export { NavbarComponent } from './shared/navbar/navbar.component';
export { MenuComponent } from './shared/menu/menu.component';
export { FooterComponent } from './shared/footer/footer.component';
export { HomeComponent } from "./home/home.component";
export { LoginComponent } from './login/login.component';
export { ServiciosComponent } from './servicios/servicios.component';
export { ServicioComponent } from './servicio/servicio.component';
export { UsuariosComponent } from './usuarios/usuarios.component';
export { UsuarioComponent } from './usuario/usuario.component';
export { SeguimientoComponent } from './seguimiento/seguimiento.component';
export { NotificacionesComponent } from './notificaciones/notificaciones.component';
export { RegistroComponent } from './registro/registro.component';



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/components/index.component.ts